"use strict";
/**
 * AI candidate features (hiring request detail):
 *   1. Candidate discovery suggestions — web search finds real candidate leads for the
 *      role, grounded in the same source information the candidate_sourcing module
 *      generation uses.
 *   2. Candidate ranking — the request's saved candidates are ranked against the
 *      role context with a summary. Re-ranks are incremental: the previous
 *      version's assessments are reused so only new candidates cost full tokens.
 *
 * Both are versioned — every manual generation from the UI creates a new version, and
 * older versions stay browsable.
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=candidate-ai.js.map